import { Component, OnInit, Input } from '@angular/core';

/**
 * LS Dropdown Component
 *
 * Never be confused by dropdown nuances ever again.
 *
 * Simply import the ls-dropdown.module.ts into your module:
 *
 ```
 import { LsDropdownModule } from 'ng2-app/components/ls-dropdown/ls-dropdown.module';

 @NgModule({
  imports: [
    LsDropdownModule
  ]
})
export class MyModule { }
```
 *
 * Then use in your module like this:
 *
```
<ls-dropdown>
  <ls-dropdown-toggle>
    <button type="button" class="btn btn-primary">
      Button dropdown <span class="caret"></span>
    </button>
  </ls-dropdown-toggle>
  <ls-dropdown-menu>
    <ul class="list-group list-unstyled">
      <li role="menuitem"><a class="dropdown-item" href="#">Action</a></li>
      <li role="menuitem"><a class="dropdown-item" href="#">Another action</a></li>
      <li role="menuitem"><a class="dropdown-item" href="#">Something else here</a></li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem"><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </ls-dropdown-menu>
</ls-dropdown>
```
 *
 * The dropdown is agnostic to toggle and menu content. You can put literally anything
 * you want inside ls-dropdown-toggle and ls-dropdown-menu and ls-dropdown handles the
 * dropdown markup, styling, and functionality. You don't have to add any classes
 * or directives to make the dropdown work.
 */
@Component({
    selector: 'ls-dropdown',
    templateUrl: './ls-dropdown.component.html',
    styleUrls: ['./ls-dropdown.component.scss'],
    standalone: false
})
export class LsDropdownComponent implements OnInit {
    @Input() placement: string;

    constructor() { }

    ngOnInit() {
        this.placement = this.placement || 'left';
    }
}
